<div
    *ngFor="let item of value; let index = index"
    class="t-circle"
    [style.left.%]="item * 100"
    (mousedown)="onMouseDown(index)"
    (dblclick)="onClick(index)"
></div>
